export class User {
  id: number = 0;
  key: number = 0;
  firstName: string = '';
  lastName: string = '';
  phoneNumber: string = '';

  // use in transacsion history
  avatar: string = '';
  notes: string = '';
  email: string = '';

  // permissions
  profileId: number = 0;
  canDelete: boolean = false;
  canViewProfile: boolean = false;
  canSelectService: boolean = false;
  canSelectStylist: boolean = false;
  canSelectDateTime: boolean = false;

  // booking fields
  selectedServices: any[] = [];
  selectedDate: any;
  selectedTime: any;

  constructor(fields) {
    Object.assign(this, fields);
  }
}



export function createUser(blob: any): User {
  return new User({
    id: blob.user_id,
    key: blob.user_id,
    firstName: blob.first_name,
    lastName: blob.last_name,
    phoneNumber: blob.mobile_phone,
    avatar: blob.avatar,
    notes: blob.notes,
    email: blob.email,
    profileId: blob.profile_id,
    canDelete: blob.can_delete,
    canViewProfile: blob.can_view_profile,
    canSelectService: blob.can_select_service,
    canSelectStylist: blob.can_select_stylist,
    canSelectDateTime: blob.can_select_date_time,

    // booking fields
    selectedServices: blob.booking_services || [],
    selectedDate: blob.booking_date,
    selectedTime: blob.booking_time,
  });
}
